import React from "react";
import "../static/bodyDescription.css";
import virtualEventsGif from "../static/images/virtualEvents.gif";

function BodyDescription() {
  return (
    <div className="contactUsBodyDescription d-flex flex-column align-items center justify-content-center">
      <img
        className="virtualEventsGif mx-auto"
        src={virtualEventsGif}
        alt="virtual events gif"
      />
      <div className="conductEventsTitle pl-xl-5 m-auto text-center mb-xl-5 mb-lg-5 mb-md-5 col-sm-10 col-10">
        Conduct Virtual Events
      </div>
      <div className="conductEventsDesc curatedDescription col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9 pl-xl-5 pl-lg-5 pl-md-5 px-sm-0 px-0 m-auto text-center">
        Organise your college and corporate fests without pain. We at Ombre got
        you covered. We conduct best virtual fests that your audience will love.
      </div>
    </div>
  );
}
export default BodyDescription;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/BodyDescription.jsx